export abstract class CapabilityCoordinatorBase<T = unknown> {
  constructor(protected readonly registry: T) {}

  public abstract cleanup(): Promise<void>;
}
